<template>
  <div class="tab-setting-detail">
    <div v-if="isActiveTitle" class="tab-setting-detail__title">
      Change password
    </div>
    <div class="tab-setting-detail__inputs">
      <b-row class="tab-setting-detail__input">
        <b-col cols="5" md="3" class="tab-setting-detail__input-label">
          <label>Current password</label>
        </b-col>
        <b-col cols="7" md="9" class="tab-setting-detail__input-item">
          <b-form-input type="password" v-model="currentPassword" />
        </b-col>
      </b-row>
      <b-row class="tab-setting-detail__line">
      <hr v-if="isActiveTitle">
      </b-row>
      <b-row class="tab-setting-detail__input">
          <b-col cols="5" md="3" class="tab-setting-detail__input-label">
          <label>New password</label>
        </b-col>
        <b-col cols="7" md="9" class="tab-setting-detail__input-item">
          <b-form-input type="password" v-model="newPassword" />
        </b-col>
      </b-row>
      <b-row class="tab-setting-detail__input">
        <b-col cols="5" md="3" class="tab-setting-detail__input-label">
          <label>Confirm password</label>
        </b-col>
        <b-col cols="7" md="9" class="tab-setting-detail__input-item">
          <b-form-input type="password" v-model="confirmPassword" />
        </b-col>
      </b-row>
    </div>
    <hr v-if="isActiveTitle">
    <div class="tab-setting-detail__button">
      <b-button @click="handleUpdatePassword">SUBMIT</b-button>
    </div>
  </div>
</template>

<script>
  import accountService from '@/services/account.service';
export default {
  props: {
    isActiveTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    handleUpdatePassword() {
      accountService.updatePassword(this.currentPassword, this.newPassword, this.confirmPassword).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Your password updated', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          })
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
        }
      },
      () => this.$bvToast.toast('Change Password failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
      }));
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/web/account/settings/_content.scss"/>
